import { render } from "./Additional.vue?vue&type=template&id=6aaa24c9"
import script from "./Additional.vue?vue&type=script&lang=js"
export * from "./Additional.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "6aaa24c9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6aaa24c9', script)) {
    api.reload('6aaa24c9', script)
  }
  
  module.hot.accept("./Additional.vue?vue&type=template&id=6aaa24c9", () => {
    api.rerender('6aaa24c9', render)
  })

}

script.__file = "src/icons/components/filled/Additional.vue"

export default script